import React, {Fragment} from 'react';
import {BlockQuote, Breadcrumb, Button, ScrollTopBtn, SecSubTitle, SecTitle, Seo, TitleWrap} from '../components';
import {
    AboutFive,
    AboutFour, AboutOne, AboutSeven, AboutSix,
    AboutThree, BrandTwo,
    ContactTwo,
    FeatureTwo,
    FooterOne,
    HeaderOneCopy,
    ProcessTwo, TestimonialTwo
} from '../containers';
import productsData from '../data/products.json';
import EVOData from "../data/EVO.json";
import AboutEight from "../containers/Abouts/AboutEight";
import AboutEightWithSideTabs from "../containers/Abouts/AboutEightWithSideTabs";
import AboutTwo from "../containers/Abouts/AboutTwo";
import AboutSevenTextImage from "../containers/Abouts/AboutSevenTextImage";
import ServiceTwoEInvoice from "../containers/Services/ServiceTwoEInvoice";
import AboutFourEInvoice from "../containers/Abouts/AboutFourEInvoice";
import FaqTwo from "../containers/Faqs/FaqTwo";
import ServiceOneEInvoice from "../containers/Services/ServiceOneEInvoice";
import AboutSevenZakta from "../containers/Abouts/AboutSevenZakta";
import ServiceOneEInvoiceKSA from "../containers/Services/ServiceOneEInvoiceKSA";
import FeatureOneEInvoice from "../containers/Features/FeatureOneEInvoice";
import Questions from "../containers/Services/Questions";
import CtaOneEInvoice from "../containers/Ctas/CtaOneEInvoice";
import ProcessTwoEInvoice from "../containers/Process/ProcessTwoEInvoice";




const keyFeatures = [
    {"id": "1", "title": "Peppol BIS 3.0 & UBL XML Support",},
    {"id": "2", "title": "ERP Integration with SAP B1, Oracle, Dynamics, and more",},
    {"id": "3", "title": "Secure Digital Signature & Certificate Management",},
    {"id": "4", "title": "Peppol Access Point Connectivity",},
    {"id": "5", "title": "Audit-Ready Archiving and Retrieval",},
    {"id": "6", "title": "Customizable Tax & VAT Rules Engine",},
    {"id": "7", "title": "Multi-language Interface & Multi-Currency Support",},
    {"id": "8", "title": "Real-time Validation & Submission via FTA infrastructure",},
    {"id": "9", "title": "Real-Time Monitoring Dashboards & Compliance Alerts",},
    {"id": "10", "title": "Scalable to Handle Large Volumes of Transactions",},
]


const aboutSeven1 = {
    image: "images/e-Invoice/e-invoice-fta.png",
    title: `The UAE E-Invoicing Landscape`,
    desc1: <>The UAE’s Federal Tax Authority is implementing an advanced national e-invoicing framework aligned with
        global standards. The system aims to streamline tax reporting, enhance transparency, and support real-time data
        exchange between taxpayers and the government.<br/>
        The UAE’s e-invoicing framework will adopt the <strong>Peppol (Pan-European Public Procurement
            Online)</strong> standard—a globally recognized interoperability framework. Peppol ensures that invoices are
        exchanged securely, efficiently, and in a standardized format across platforms and borders.<br/>
        Key components of the UAE e-invoicing structure include:</>,
    desc2: <>
        In addition, the UAE’s e-invoicing strategy is designed to enhance operational efficiency by automating manual processes, ensuring real-time invoice traceability, and enabling simplified cross-border trade. Businesses that adopt compliant platforms will benefit from reduced costs, improved accuracy, and faster reconciliation cycles.<br/>
        Our solution is fully Peppol-ready, ensuring you are compliant with the UAE’s vision for smart and secure tax digitization.
    </>,
    point: [
        <><strong>Peppol BIS 3.0 Format: </strong>Invoices must be submitted in a standardized UBL (Universal Business Language) XML format.</>,
        <><strong>Peppol Access Point (AP): </strong>A secure gateway through which invoices are sent and received.</>,
        <><strong>Digital Signatures:  </strong>Every invoice must be digitally signed to ensure authenticity and integrity.</>,
        <><strong>Real-Time Exchange:  </strong>Once submitted, invoices are validated and acknowledged by the FTA system via the Peppol network.</>,
    ],
    isWide: true
}


const aboutSeven2 = {
    image: "images/e-Invoice/e-invoice-7.jpeg",
    title: `Who Should Prepare?`,
    desc1: "All VAT-registered businesses in the UAE should begin planning for E-Invoicing now. These include:",
    desc2: "Being prepared now ensures a smoother transition once FTA requirements go live.",
    point: [
        "Retail & Wholesale Companies",
        "Service-Based Firms",
        "Importers & Exporters",
        "E-Commerce Businesses",
    ],

}



const aboutFourData = {
    title: 'Why Choose Us?',
    subtitle: 'All Your needs in our system',
    images: [
        "/images/solutions/solutions-1.jpeg",
        "/images/solutions/solutions-2.jpg",
    ],
    points: [
        {
            title: "Built for UAE",
            text: "Designed specifically for the FTA’s digital roadmap"
        },
        {
            title: "ERP Native",
            text: "Easy integration with your current invoicing system"
        },
        {
            title: "Secure & Compliant",
            text: "Meets international and regional data standards"
        },
        {
            title: "Peppol-Ready",
            text: " Full support for UBL, BIS 3.0, and access point integration"
        },
        {
            title: "Future-Proof",
            text: "Auto-updates as FTA finalizes its invoicing model"
        },
        {
            title: "Real-Time Compliance Reporting",
            text: "Stay on top of status, errors, and exceptions"
        },
        {
            title: "Trusted Partner",
            text: "Supporting UAE businesses across industries"
        },

    ]


}



const questions = [
    {
        questionId: 1,
        question: "Is E-Invoicing mandatory now in the UAE?  ",
        answer: "Not fully, but businesses are expected to be ready for a digital tax future.",
    },
    {
        questionId: 2,
        question: "What is the FTA’s expected direction? ",
        answer: "Peppol-based structured electronic invoices, real-time submissions, and audit-readiness.",
    },
    {
        questionId: 3,
        question: "Can you integrate with our ERP?  ",
        answer: "Yes, we have ready-made connectors and APIs for most major ERP systems.",
    },
    {
        questionId: 4,
        question: "Will I need to reconfigure my entire system?",
        answer: "No. Our solution works with your existing processes and enhances them.",
    },
    {
        questionId: 5,
        question: "Is your platform scalable for high-volume businesses? ",
        answer: "Absolutely. Our infrastructure is designed to handle high transaction volumes with real-time monitoring.",
    },
]

const processData = [
    {
        "number": "01",
        "arrow": "images/icon/process-arrow-1-1.png",
        "arrow2": "images/icon/process-arrow-2-1.png",
        "icon": "images/icon/process-1-2.png",
        "title": "Assessment & Planning",
        "text": "We evaluate your invoicing flow and ERP systems."
    },
    {
        "number": "02",
        "arrow": "images/icon/process-arrow-1-1.png",
        "arrow2": "images/icon/process-arrow-2-1.png",
        "icon": "images/icon/fe-2-2.png",
        "title": "Implementation",
        "text": "Setup of digital invoicing workflows with Peppol alignment."
    },
    {
        "number": "03",
        "arrow": "images/icon/process-arrow-1-1.png",
        "arrow2": "images/icon/process-arrow-2-1.png",
        "icon": "images/icon/process-1-1.png",
        "title": "Configuration",
        "text": "VAT rules, templates, and invoice structure based on BIS 3.0."
    },
    {
        "number": "04",
        "arrow": "images/icon/process-arrow-1-1.png",
        "arrow2": "images/icon/process-arrow-2-1.png",
        "icon": "images/icon/sr-icon-3-4.png",
        "title": "FTA Readiness Audit",
        "text": "Ensure you’re aligned with expected guidelines."
    },
    {
        "number": "05",
        "arrow": "images/icon/process-arrow-1-1.png",
        "arrow2": "images/icon/process-arrow-2-1.png",
        "icon": "images/icon/process-2-3.png",
        "title": "Go-Live",
        "text": "Launch the system with live invoice generation and archiving."
    }
];


const ctaData = {
    title:"Start Preparing Today",
    subTitle:"Get a head start on compliance and digital transformation in the UAE.",
    image:'images/e-invoice/e-invoice-8.png',
    buttons:[
        {title:"Talk to an Expert",path:"/contact"},
        {title:"Contact Us",path:"/contact"},
    ]
}


const EInvoiceUAE = () => (
    <Fragment>
        <Seo title="E-Invoicing for UAE"/>
        <HeaderOneCopy/>
        <Breadcrumb pageName="E-Invoicing for UAE"
                    pageSubTitle={"E-Invoicing Made Simple & Compliant"}
                    pageDesc={"Powerful, scalable solutions for digital invoicing across regions."}
                    bgImage="images/bg/bg-e-invoice.png"
                    button={<Button path={'/e-invoicing-risk-assessment'} className="style2">REQUEST E-Invoicing Risk Assessment<i className="far fa-arrow-right"/></Button>}
        />


        <div className="container space-extra-bottom">
            <TitleWrap className="text-center space-top ">
                <SecSubTitle>Get Future-Ready with UAE-Compliant E-Invoicing Solutions</SecSubTitle>
                <SecTitle className="text-capitalize h1">E-Invoicing in the UAE (FTA Readiness)</SecTitle>
            </TitleWrap>

            <p className="author-degi  text-center"> The United Arab Emirates is preparing for a nationwide shift toward E-Invoicing, led by the Federal Tax Authority (FTA). Our platform is designed to help businesses comply with current tax laws and be ready for the upcoming digital invoicing mandates.</p>

        </div>

        <AboutSevenZakta data={aboutSeven1}/>

        <ServiceOneEInvoiceKSA
            title={"Our FTA-Ready Features"}
            data={keyFeatures}

        />

        <AboutSevenZakta data={aboutSeven2} reverse={true}/>


        <ProcessTwoEInvoice
            data={processData} title={"Our Readiness Process"}
            className="space-top space-extra-bottom"
        />

        <AboutFour data={aboutFourData} className="space space-top mt-5"/>


        {/*<div className="container">
            <BlockQuote
                text="We are proud to be officially listed as an Accredited E-Invoicing Service Provider by the Ministry of Finance of the UAE. This certification confirms our compliance with government standards, ensuring you receive a trusted and recognized solution."
                author="Accredited by the UAE Ministry of Finance"
            />
        </div>
*/}
        <Questions  className={'space-bottom'}  questions={questions}/>

        <CtaOneEInvoice
            data={ctaData}
        />
        <FooterOne/>

        <ScrollTopBtn/>
    </Fragment>
);

export default EInvoiceUAE;